<template>
  <div class="mt-1">
    <div class="card mb-3">
      <div class="card-body">
        <lev-table
            class="lev-table"
            :table-data="dataObjectList"
            :fields="tableColumns"
            :searchalbe-fields="searchableFields"
            :extended-fields="extendtedFields"
            :visible-fields="visibleFields"
        >
          <template #provider="{ item }">
            <a :href="item['provider_url']" target="_blank">
              <img :src="item['provider_image']" alt="provider" class="me-1" style="width: 2.5em;"/>
              <strong>{{ item['provider_name'] }}</strong>
            </a>
          </template>
          <template #price="{ item }">
            <strong>{{ USDCurrencyFormat(item['price']) }}</strong>
          </template>
          <template #cdkey="{ item }">
            <div class="d-flex d-inline align-items-center justify-content-between">
              <strong>{{ item['cdkey'] }}</strong>
              <div>
                <lev-icon icon="fas fa-copy" tooltip="Copy to clipboard" @click="copyToClipboard(item['cdkey'])"></lev-icon>
              </div>
            </div>
          </template>
          <template #remark="{ item }">
            <div class="d-flex d-inline align-items-center justify-content-between w-100" v-if="item['is_edit_remark']">
              <lev-input class="w-100" v-model="item['remark_editing']" form-type="dynamic" placeholder="Enter remark here..."></lev-input>
              <div class="d-flex gap-1">
                <div v-if="item['is_edit_confirming']">
                  <lev-icon icon="fas fa-sync fa-spin" variant="info" tooltip="Saving..." readonly></lev-icon>
                </div>
                <div class="d-flex d-inline gap-1" v-else>
                  <lev-icon icon="fas fa-check" variant="success" tooltip="Save Remark" @click="confirmEditRemark(item)"></lev-icon>
                  <lev-icon icon="fas fa-times" variant="danger" tooltip="Cancel" @click="cancelEditRemark(item)"></lev-icon>
                </div>
              </div>
            </div>
            <div class="d-flex d-inline align-items-center justify-content-between" v-else>
              <span v-if="item['remark']" v-html="item['remark']"></span>
              <span v-else class="text-muted">-</span>
              <lev-icon icon="fas fa-edit" variant="info" tooltip="Edit Remark" @click="editRemark(item)"></lev-icon>
            </div>
          </template>
          <template #created_at="{ item }">
            {{ convertISODate(item['created_at']) }}
          </template>
        </lev-table>
      </div>
    </div>
  </div>
</template>

<script>

import dataRequester from "@/mixins/utilities/DataRequester";
import dataObjectListMixin from "@/mixins/DataObjectList";
import inputHelper from "@/mixins/utilities/InputHelper";

import LevTable from "@/components/children/LevTable2.vue";
import LevIcon from "@/components/children/lev_components/LevIcon.vue";
import LevInput from "@/components/children/lev_components/LevInput.vue";

export default {
  name: "RsdProxyCDKey",
  mixins: [
    dataRequester,
    dataObjectListMixin,
    inputHelper
  ],
  components: {
    LevInput,
    LevTable,
    LevIcon
  },
  data () {
    return {
      tableColumns: [
        {
          name: "provider",
          title: "Provider",
          sortField: "provider",
        },
        {
          name: 'package_name',
          title: "Package",
          sortField: "package",
        },
        {
          name: 'price',
          title: "Price",
          sortField: "price",
        },
        {
          name: 'cdkey',
          title: "CD Key",
          sortField: "cdkey",
        },
        {
          name: 'remark',
          title: "Remark",
          sortField: "remark",
        },
        {
          name: 'created_at',
          title: "Created At",
          sortField: "created_at",
        }
      ],
      searchableFields: [],
      extendtedFields: [
        {
          name: 'is_edit_remark',
          extended_data: false,
          visible: false
        },
        {
          name: 'is_edit_confirming',
          extended_data: false,
          visible: false
        }
      ],
      visibleFields: []
    }
  },
  created() {
    this.listAllCdKeys()
  },
  methods: {
    listAllCdKeys () {
      const self = this
      this.getDataFromAPI(this.$config.apiPath.rsdProxyCdKeys, function (result) {
        //sort by created_at desc
        self.dataObjectList = result.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      })
    },

    copyToClipboard (text) {
      this.copyValueToClipboard(text)
      this.$toasted.success("Copied to clipboard")
    },
    editRemark(rowData) {
      rowData['is_edit_remark'] = true
      rowData['remark_editing'] = rowData['remark']
    },
    confirmEditRemark(rowData) {
      const self = this
      rowData['is_edit_confirming'] = true
      this.submitObjectList(this.$config.apiPath.rsdProxyCdKeysUpdateRemark, {
        id: rowData['id'],
        remark: rowData['remark_editing']
      }, 'cdKeyObj', undefined, function (result) {
        rowData['is_edit_remark'] = false
        rowData['remark'] = rowData['remark_editing']
        self.$toasted.success("Remark updated successfully")
      }, function (err) {
        rowData['is_edit_remark'] = true
      }, true, function () {
        rowData['is_edit_confirming'] = false
      })
    },
    cancelEditRemark(rowData) {
      rowData['is_edit_remark'] = false
    }
  }
}
</script>
